<template lang="html">
    <v-layout row wrap justify-center align-center style="height: 100vh">
      <v-col cols="8" align="center" justify="center">
        <img :src="img_err" :alt="img_err" style="height: 20vh !important" />
        <p
          class="mt-2 text-uppercaser"
          style="color: #ae0000"
        >
          <b>{{ message_error }}</b>
        </p>
        <!-- <p class="mt-2" style="color: #ae0000">
          {{ message_error }}
        </p> -->
        <v-btn color="#083f5e" @click="toPage()" rounded dark>{{$t('Login.Button.login')}}</v-btn>
      </v-col>
    </v-layout>
  </template>
  
  <script>
  export default {
    data() {
      return {
        img_err: "",
        message_err: "",
        publicPath: process.env.VUE_APP_BASE_PATH,
      };
    },
    computed: {
    //   mainFontSize() {
    //     return { fontSize: this.$store.getters.mainFontSize };
    //   },
    //   subFontSize() {
    //     return { fontSize: this.$store.getters.subFontSize };
    //   },
    },
    created() {
      this.message_error = this.$route.query.message_err;
      if (this.$route.query.type_err === "401") {
        this.img_err = `${this.publicPath}/assets/img/pagedefault/error_401.jpg`;
        } else if (this.$route.query.type_err === "400") {
            this.img_err = `${this.publicPath}/assets/img/pagedefault/error_400.jpg`;
        } else if (this.$route.query.type_err === "404") {
            this.img_err = `${this.publicPath}/assets/img/pagedefault/error_404.jpg`;
        } else if (this.$route.query.type_err === "500") {
            this.img_err = `${this.publicPath}/assets/img/pagedefault/error_500.jpg`;
        } else if (this.$route.query.type_err === "503") {
            this.img_err = `${this.publicPath}/assets/img/pagedefault/error_503.jpg`;
        } else {
            this.img_err = `${this.publicPath}/assets/img/pagedefault/error_none.jpg`;
        }
    },
    methods: {
        toPage() {
            window.open(process.env.VUE_APP_URL_PRIVATE + '/login', "_self")
        },
    }
  };
  </script>
  
  <style lang="css" scoped>
  .text-uppercaser {
    text-transform: uppercase;
  }
  </style>
  